import { useContext, useState } from "react";
import HouseCoordinates from "../houseCoordinates";
import PropertySurroundings from "../propertySurroundings";
import DOMPurify from "dompurify";
import { HouseCompetitionData } from "@/app/(custom-header)/prizes/house-v2/contextProvider";

// accordion constants
const AccordionDetails = () => {
  const [open, setOpen] = useState({
    one: false,
    two: false,
    three: false,
    four: false,
  });

  const toggleSection = (key: "one" | "two" | "three" | "four") => {
    setOpen(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const { detailsText, cashAlternativeText } = useContext(HouseCompetitionData);

  return (
    <>
      <div className={"flex flex-col gap-4 font-jost lg:w-[1000px] lg:mx-auto"}>
        {/* EXPAND 1 */}
        <div className={""}>
          <div onClick={() => toggleSection("one")} className={"flex gap-3 cursor-pointer"}>
            <div className={""}>
              <img
                src={"/assets/images/house-competition/accordion-icon-pin.svg"}
                alt={"Where you'll be"}
                className={"size-12 lg:size-16 shrink-0 aspect-[1/1]"}
              />
            </div>
            <div className={`w-full grow pb-4 ${!open.one ? "border-b border-black/8" : ""}`}>
              <div className={"flex items-center h-12 lg:h-16"}>
                <div className={"text-dark-1 text-base lg:text-2xl leading-5.5 lg:leading-7.5 font-medium"}>
                  Where you'll be
                </div>
                <div className={`ml-auto transition-transform duration-200 ${open.one ? "rotate-180" : "rotate-0"}`}>
                  <img
                    src={"/assets/images/house-competition/accordion-arrow.svg"}
                    alt={"Arrow"}
                    className={`size-6 lg:size-8 shrink-0 aspect-[1/1]`}
                  />
                </div>
              </div>
            </div>
          </div>
          {/*content 1*/}
          <div
            className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
              open.one ? "grid-rows-[1fr] opacity-100 pt-2 pb-6 border-b border-black/8" : "grid-rows-[0fr] opacity-0"
            }`}>
            <div className={"overflow-hidden"}>
              <HouseCoordinates />
            </div>
          </div>
        </div>

        {/* EXPAND 2 */}
        <div className={""}>
          <div onClick={() => toggleSection("two")} className={"flex gap-3 cursor-pointer"}>
            <div className={""}>
              <img
                src={"/assets/images/house-competition/accordion-icon-map.svg"}
                alt={"Where you'll be"}
                className={"size-12 lg:size-16 shrink-0 aspect-[1/1]"}
              />
            </div>
            <div className={`w-full grow pb-4 ${!open.two ? "border-b border-black/8" : ""}`}>
              <div className={"flex items-center h-12 lg:h-16"}>
                <div className={"text-dark-1 text-base lg:text-2xl leading-5.5 lg:leading-7.5 font-medium"}>
                  Property surroundings
                </div>
                <div className={`ml-auto transition-transform duration-200 ${open.two ? "rotate-180" : "rotate-0"}`}>
                  <img
                    src={"/assets/images/house-competition/accordion-arrow.svg"}
                    alt={"Arrow"}
                    className={`size-6 lg:size-8 shrink-0 aspect-[1/1]`}
                  />
                </div>
              </div>
            </div>
          </div>
          {/*content 2*/}
          <div
            className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
              open.two ? "grid-rows-[1fr] opacity-100 pt-2 pb-6 border-b border-black/8" : "grid-rows-[0fr] opacity-0"
            }`}>
            <div className={"overflow-hidden"}>
              <PropertySurroundings />
            </div>
          </div>
        </div>

        {/* EXPAND 3 */}
        <div className={""}>
          <div onClick={() => toggleSection("three")} className={"flex gap-3 cursor-pointer"}>
            <div className={""}>
              <img
                src={"/assets/images/house-competition/accordion-icon-pound.svg"}
                alt={"Where you'll be"}
                className={"size-12 lg:size-16 shrink-0 aspect-[1/1]"}
              />
            </div>
            <div className={`w-full grow pb-4 ${!open.three ? "border-b border-black/8" : ""}`}>
              <div className={"flex items-center h-12 lg:h-16"}>
                <div className={"text-dark-1 text-base lg:text-2xl leading-5.5 lg:leading-7.5 font-medium"}>
                  <span>{cashAlternativeText}</span> cash alternative
                </div>
                <div className={`ml-auto transition-transform duration-200 ${open.three ? "rotate-180" : "rotate-0"}`}>
                  <img
                    src={"/assets/images/house-competition/accordion-arrow.svg"}
                    alt={"Arrow"}
                    className={`size-6 lg:size-8 shrink-0 aspect-[1/1]`}
                  />
                </div>
              </div>
            </div>
          </div>
          {/*content 3*/}
          <div
            className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
              open.three ? "grid-rows-[1fr] opacity-100 pt-2 pb-6 border-b border-black/8" : "grid-rows-[0fr] opacity-0"
            }`}>
            <div className={"overflow-hidden text-dark-1 text-base lg:text-lg leading-5.5 lg:leading-6 font-normal"}>
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(cashAlternativeText),
                }}
              />{" "}
              Tax-Free Cash.
            </div>
          </div>
        </div>

        {/* EXPAND 4 */}
        <div className={""}>
          <div onClick={() => toggleSection("four")} className={"flex gap-3 cursor-pointer"}>
            <div className={""}>
              <img
                src={"/assets/images/house-competition/accordion-icon-info.svg"}
                alt={"Where you'll be"}
                className={"size-12 lg:size-16 shrink-0 aspect-[1/1]"}
              />
            </div>
            <div className={`w-full grow pb-4`}>
              <div className={"flex items-center h-12 lg:h-16"}>
                <div className={"text-dark-1 text-base lg:text-2xl leading-5.5 lg:leading-7.5 font-medium"}>
                  More details
                </div>
                <div className={`ml-auto transition-transform duration-200 ${open.four ? "rotate-180" : "rotate-0"}`}>
                  <img
                    src={"/assets/images/house-competition/accordion-arrow.svg"}
                    alt={"Arrow"}
                    className={`size-6 lg:size-8 shrink-0 aspect-[1/1]`}
                  />
                </div>
              </div>
            </div>
          </div>
          {/*content 4*/}
          <div
            className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
              open.four ? "grid-rows-[1fr] opacity-100 pt-2 pb-6" : "grid-rows-[0fr] opacity-0"
            }`}>
            <div className={"overflow-hidden"}>
              <div
                className={"qqq-text-gray-1 qqq-dynamicTextHeadings"}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(detailsText),
                }}
              />
            </div>
          </div>
        </div>

        {/*END*/}
      </div>
    </>
  );
};

export default AccordionDetails;
